module.exports = __webpack_public_path__ + "img/user.5f82c5c2.png";